var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationDashboardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "notification_3602091",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_8_1",
    "data-name": "Component 8 \\u2013 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28964",
    "data-name": "Group 28964",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39849",
    "data-name": "Path 39849",
    d: "M10,24a3.756,3.756,0,0,0,3.674-3H6.326A3.756,3.756,0,0,0,10,24Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_39850",
    "data-name": "Path 39850",
    d: "M17.576,14.5c-.026,0-.05,0-.076,0A7.987,7.987,0,0,1,11,1.854V1A1,1,0,1,0,9,1V2.08A7,7,0,0,0,3,9v2.788A6.705,6.705,0,0,1,.612,16.921,1.75,1.75,0,0,0,1.75,20h16.5a1.749,1.749,0,0,0,1.128-3.087A6.708,6.708,0,0,1,17.576,14.5Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationDashboardIcon);
export default __webpack_public_path__ + "static/media/notification_dashboard_icon.36a5ad8938363768a1e308787148bddb.svg";
export { ForwardRef as ReactComponent };